import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import {ReactComponent as Cross} from '../../assets/cross.svg'
import {ReactComponent as Burger} from '../../assets/hamburger.svg'
import {ReactComponent as ArrowDown} from '../../assets/arrowDown.svg'
import {ReactComponent as ArrowRightGrey} from '../../assets/arrowRight.svg'
//import Button from '../Button';


function Navbar() {
    const [click, setClick]= useState(false);
    const handleClick = ()=> setClick(!click);

    return (
    <div className="header">
        <nav className="navbar">
            <div className="content">
                <div className="navbar-main">
                    <Link to="/" className="logo" onClick={handleClick}>
                        <a className="title" href="/">Agencia Digital</a>
                    </Link>    
                    <div className="menu-icon" onClick={handleClick}>
                        {click ? <Cross/> : <Burger /> }
                    </div>
                </div>

                <ul className={click ? "nav-menu-active" : "menu-items"}>

                    <div className="desktopMenu">
                        <li className="dropdown">
                            
                            <Link to="/" className="nav-links">
                                <a className="link" href="/">Servicios<ArrowDown style={{marginLeft:"9.5px", verticalAlign:"middle"}}/></a>
                            </Link>
                            <div className="dropdown-menu-wrapper">
                            <ul className="dropdown-menu">
                                <div className="dropdown-menu-tomorrow">
                                    <p className="tomorrowContent">Tomorrow it's <br/>calling.</p>
                                </div>                                
                                <div className="dropdown-menu-left">                            
                                    <p className="dropdown-menu-sub">Internet</p>
                                    <li className="menu-item">
                                        <Link to="/Posicionamiento" className="drop-links">
                                            <a className="link" href="/Posicionamiento">Posicionamiento</a>
                                        </Link>
                                    </li>                                
                                    <li className="menu-item">
                                        <Link to="/Analitica" className="drop-links">
                                            <a className="link" href="/Analitica">Analítica de datos</a>
                                        </Link>
                                    </li>
                                </div>
                                <div className="dropdown-menu-right">
                                    <p className="dropdown-menu-sub">Producto</p>
                                    <li className="menu-item">
                                        <Link to="/Desarrollo" className="drop-links">
                                            <a className="link" href="/Desarrollo">Desarrollo</a>
                                        </Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/VisualDesign" className="drop-links">
                                            <a className="link" href="/VisualDesign">UX/UI & Visual Design</a>
                                        </Link>
                                    </li>
                                </div>
                            </ul>
                            </div>
                        </li>                        
                            <li className="nav-item">
                                <Link to="/Proyectos" className="nav-links">
                                    <a className="link" href="/Proyectos">Proyectos</a>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Empresa" className="nav-links">
                                    <a className="link-end" href="/Empresa">Empresa</a>
                                </Link>
                            </li>
                    </div>

                    <div className="mobileMenu">
                        <div className="mobileMenuWrapper">
                            <p className="mobile-menu-tomorrow">Tomorrow it's calling.</p>                        
                            <input type="checkbox" className="checkbox" id="showDrop"/>
                            <label for="showDrop" className="link">
                                <li className="nav-item">Servicios<ArrowRightGrey style={{marginLeft:"9.5px"}}/></li>
                            </label>
                            <ul className="drop-menu">  
                                <li className="dropMenu-item"> 
                                    <Link to="/Posicionamiento" onClick={handleClick}> 
                                        <a className="dropdown-link" href="/Posicionamiento">Posicionamiento</a>
                                    </Link>
                                </li>
                                <li className="dropMenu-item">
                                    <Link to="/Analitica" onClick={handleClick}>
                                        <a className="dropdown-link" href="/Analitica">Analítica de datos</a>
                                    </Link>
                                </li>
                                <li className="dropMenu-item">
                                    <Link to="/Desarrollo" onClick={handleClick}>
                                        <a className="dropdown-link" href="/Desarrollo">Desarrollo</a>
                                    </Link>
                                </li>
                                <li className="dropMenu-item">
                                    <Link to="/VisualDesign" onClick={handleClick}>
                                        <a className="dropdown-link" href="/VisualDesign">UX/UI & Visual Design</a>
                                    </Link>
                                </li>
                            </ul>
                            <li className="nav-item">
                                <Link to="/Proyectos" className="nav-links" onClick={handleClick}>
                                    <a className="link" href="/Proyectos">Proyectos</a>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/Empresa" className="nav-links" onClick={handleClick}>
                                    <a className="link" href="/Empresa">Empresa</a>
                                </Link>
                            </li>
                            {/*<li className="nav-contacto">
                                <Link to="#"  onClick={handleClick}>
                                    <Button style={{}} contacto="Contáctanos"/>
                                </Link>
                            </li> */}
                        </div>
                    </div>
                </ul>

                

            </div>
        </nav>
    </div>
    );
}

export default Navbar;